<template>
  <div>
    <h5>
      Originating details
    </h5>
    <p></p>
    <b-form>
      <b-row>
        <b-col lg="4" class="mb-1">
          <b-form-group label="Location" label-for="location" description="제품의 생산위치">
            <b-input-group>
              <b-input id="location" v-model="form.location"></b-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="4" class="mb-1">
          <b-form-group label="Date" label-for="Date" description="제품의 생산일을 선택합니다.">
            <b-input-group>
              <b-form-datepicker v-model="form.createDate" id="Date"></b-form-datepicker>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="4" class="mb-1">
          <b-form-group label="Time" label-for="Time" description="제품의 생산시간은 수정불가">
            <b-input-group>
              <b-form-timepicker v-model="form.createTime" locale="ko"></b-form-timepicker>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-1">
          <ProductDetailsVue v-if="onComplate" :scenario=scenario :param=form @OnValidate="validate"></ProductDetailsVue>
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col lg="12">
          <b-button-group>
            <b-button style="width:150px" squared type="submit" :variant="`${!standby ? '': 'dark'}`"
              :disabled="!standby">
              <b-icon v-if="standby" icon="circle-fill" animation="throb"></b-icon>
              Submit
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-form>
  </div>

</template>

<script>

// import FromSelectProduct from '../../FromSelectProduct.vue'
// import FromSelectFacility from '../../FromSelectFacility.vue'

import hal from 'hateoas-hal-link-resolver'
import ProductDetailsVue from './ProductDetails.vue';
import moment from 'moment'
// import { VueScrollPicker } from 'vue-scroll-picker'

export default {
  props: {
    scenario: {
      type: Object
    },
    flow: {
      type: Object
    }
  },
  components: {
    // OverayVue,
    // FromSelectProduct,
    // FromSelectFacility
    ProductDetailsVue,
  },

  async beforeMount() {
    await this.getBizLocation();
    this.onComplate = true;
  },
  data() {
    return {
      onComplate: false,
      standby: false,
      opt: { show: false },
      form: {
        actions: 'CREATE_HARVEST_ETC',
        location: '',
        products: [],
        createDate: new Date(),
        createTime: moment().format('HH:mm:ss')
      },

    }
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      this.opt.show = !this.opt.show;
      // alert(JSON.stringify(this.form))
      try {
        await this.$http.patch(`${hal(this.scenario, 'scenarioEvents')}/${this.form.actions}`, this.form);
        this.$emit('OnSubmit');
      } catch (err) {
        alert(err)
      } finally {
        this.opt.show = false;
      }

    },

    async getBizLocation() {
      try {
        const response = await this.$http.get(hal(this.flow, 'bizLocation'));
        const bizlocation = response.data;
        this.form.location = bizlocation.facilityName;
        this.form.bizLocation = hal(bizlocation, 'self')
        // console.log(this.form)
      } catch (err) {
        console.error(err);
      }
    },
    validate(bool){
      // console.log(bool)
      this.standby = bool
    }
  },

  watch: {

  }
}
</script>